package org.chiangmeng.qfast.core.ui.customer

import org.chiangmeng.qfast.core.domain.models.QueueTicket
import org.chiangmeng.qfast.core.domain.models.Shop

interface CustomerContract {
    data class State(
        val shop: Shop? = null,
        val queues: List<QueueTicket> = emptyList(),
        val customerTicketInput: String = "",
        val statusMessage: String? = null,
        val isLoading: Boolean = false,
        val newlyIssuedTicket: String? = null
    )

    sealed class Intent {
        data class LoadShop(val shopId: String) : Intent()
        data class UpdateTicketInput(val input: String) : Intent()
        data class IssueTicket(val category: String) : Intent()
        object DismissSuccessDialog : Intent()
        data object StopObserving : Intent()
    }
}